// extracted by mini-css-extract-plugin
module.exports = {"modalCard":"ModalCard_modalCard__32i5j","active":"ModalCard_active__3mZAH","modalCardContent":"ModalCard_modalCardContent__18SpW","userName":"ModalCard_userName__3ogh8"};